// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card[data-v-76b966cd] {\n  width: 300px;\n  height: 455px;\n  background: #ffffff;\n  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n  border-radius: 20px !important;\n  margin-top: 1.5rem;\n  position: relative;\n  padding: 2rem 1.5rem;\n  position: relative;\n}", ""]);
// Exports
module.exports = exports;
